export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

export const SUCCESS_NOTIFICATION = 'success';
export const WARNING_NOTIFICATION = 'warning';
export const DANGER_NOTIFICATION = 'danger';
export const INFO_NOTIFICATION = 'info';